
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lookbook/image",
      function () {
        return require("private-next-pages/lookbook/image.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lookbook/image"])
      });
    }
  